'use client'
import logoSecondary from '@/assets/img/logo-2.webp';
import logoPrimary from '@/assets/img/logo.webp';
import {useTranslations} from 'next-intl';
import {useCommonDataContext} from '@/providers/CommonDataContext';
import LogoImage from '@/components/layout/headers/LogoImage';

export default function Copyright({home, footerBg}) {
  const {common} = useCommonDataContext();
  const t = useTranslations('footer');
  
  return (
      <div className="ltn__copyright-area ltn__copyright-2">
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-12">
              <div className="site-logo-wrap">
                <LogoImage
                    logoSrc={footerBg === "dark"
                        ? (home?.secondaryShopLogo ?? common?.home?.secondaryShopLogo ?? logoSecondary)
                        : (home?.primaryShopLogo ?? common?.home?.primaryShopLogo ?? logoPrimary)}
                />
                <div className="get-support ltn__copyright-design clearfix">
                  <div className="get-support-info">
                    <h6>{t('copyright')}</h6>
                    <h4>
                      {t('title')} - { new Date().getFullYear() }
                    </h4>
                  </div>
                </div>
              </div>
            </div>
            {/*<div className="col-md-6 col-12 align-self-center">*/}
            {/*  <div className="ltn__copyright-menu text-end">*/}
            {/*    <ul>*/}
            {/*      <li>*/}
            {/*        <a href="#">Terms & Conditions</a>*/}
            {/*      </li>{" "}*/}
            {/*      <li>*/}
            {/*        <a href="#">Claim</a>*/}
            {/*      </li>{" "}*/}
            {/*      <li>*/}
            {/*        <a href="#">Privacy & Policy</a>*/}
            {/*      </li>*/}
            {/*    </ul>*/}
            {/*  </div>*/}
            {/*</div>*/}
          </div>
        </div>
      </div>
  );
};
